import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

interface League {
  id: number;
  logo: string;
  title: string;
  sport: number;
  link: string;
  dates: Array<{
    date: string;
    matches: Array<{
      id: number;
      matchId?: number; // DB primary key for admin game creation
      time: string;
      date: string;
      status: number;
      statusTitle: string;
      host: {
        id: number;
        name: string;
        logo: string;
        style?: {
          backgroundColor: string;
          font: number;
          fontColor: string;
        };
      };
      guest: {
        id: number;
        name: string;
        logo: string;
        style?: {
          backgroundColor: string;
          font: number;
          fontColor: string;
        };
      };
      link: string;
      isLive: boolean;
      liveTime: string;
      hasDetails: boolean;
      liveStream?: {
        link: string;
      };
      goals?: {
        host: number;
        guest: number;
      };
      winner?: number;
    }>;
  }>;
}

const fetchLiveScores = async (): Promise<League[]> => {
  const response = await apiClient.get("/livescores");
  return response.data;
};

export const useLiveScores = (
  options?: Omit<UseQueryOptions<League[], Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["livescores"],
    queryFn: fetchLiveScores,
    staleTime: 2 * 60 * 1000, // 2 minutes - scores update frequently
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    ...options,
  });
};
